import React from 'react';

const NotesComponent: React.FC<{ note: string; setNote: (note: string) => void }> = ({ note, setNote }) => {
  const handleNotesChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setNote(e.target.value);
  };

  const maxReasonLength = 240;

  return (
    <div style={styles.container}>
      <div style={{ minHeight: '0.8vh' }} />
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          width: '100%',
          justifyContent: 'space-between',
        }}
      >
        <div style={styles.title}>Notes</div>
        <div style={styles.label}>
          {note.length}/{maxReasonLength}
        </div>
      </div>
      <div style={{ minHeight: '0.8vh' }} />
      <textarea
        placeholder="Add notes..."
        value={note}
        onChange={handleNotesChange}
        style={styles.textarea}
        rows={4}
        maxLength={maxReasonLength}
      />
      <div style={{ minHeight: '0.8vh' }} />
    </div>
  );
};

const styles = {
  container: {
    width: '100%',
    borderRadius: '1.6vh',
    display: 'flex',
    flexDirection: 'column' as 'column',
  },
  title: {
    fontSize: '1.4vh',
    fontWeight: '700',
    color: '#101D3B',
    textAlign: 'left' as 'left',
  },
  textarea: {
    width: '100%',
    padding: '1.6vh',
    fontSize: '1.4vh',
    fontWeight: '400',
    borderRadius: '1.6vh',
    border: '0.1vh solid rgba(16, 29, 59, 0.2)',
    backgroundColor: '#ffffff',
    color: '#101D3B',
    outline: 'none',
    resize: 'none',
    minHeight: '7vh',
    maxHeight: '7vh',
    boxSizing: 'border-box' as 'border-box',
    fontFamily: 'inherit',
    transition: 'border-color 0.2s',
  } as React.CSSProperties,
  label: {
    fontSize: '1.2vh',
    fontWeight: '400',
    color: 'rgba(16, 29, 59, 0.6)',
  },
};

export default NotesComponent;
